import React, { useState, useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { Button_s, Label_s} from 'styles/app-styles'

const SalesInherit = (props: {rowData: [], field: string, namedItems: {}, defaults: {}, persist: Function}) => {
  const [data, setData] = useState<object|null>(_.get(props, "rowData.salesdetail"));

  const emptyRecord = {}

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field]['state'] !== 'inherit') setData(emptyRecord)
  }, [props['rowData']])

  function updateData():void {
    let nextData:object

    nextData = {
      state: 'inherit',
      sales: 'Inherit'
    }

    setData(nextData);
    props.persist(nextData, 'salesdetail', props.rowData)
  }

  const isInherit = _.get(data, 'state') == 'inherit'

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          { isInherit
            ? <Label_s>Inherit Selected</Label_s>
            : <Button_s className="rounded btn" onClick={() => updateData()}>Select Inherit</Button_s>
          }
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default SalesInherit
